import { createApp } from "vue";
import { createVuestic } from "vuestic-ui";
import { apiPlugin, StoryblokVue } from "@storyblok/vue";

import stores from "./stores";
import router from "./router";
import vuesticGlobalConfig from "./services/vuestic-ui/global-config";
import App from "./App.vue";

const app = createApp(App);

const storyblokToken = import.meta.env.VITE_STORYBLOK_ACCESS_TOKEN;
if (typeof storyblokToken === "string" && storyblokToken.length > 0) {
  app.use(StoryblokVue, { accessToken: storyblokToken, use: [apiPlugin] });
}

app.use(stores);
app.use(router);
app.use(createVuestic({ config: vuesticGlobalConfig }));
app.config.errorHandler = (err, vm, info) => {
  console.error(err, vm, info);
};

app.mount("#app");
